import ForgotPassScreen from './ForgotPassScreen';

export default ForgotPassScreen;